import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "components/sidebar/Sidebar";
import Navbar from "components/navbar/NavbarAdmin";
import Footer from "components/footer/FooterAdmin";
import routes from "routes";
import { IntervalProvider } from "contexts/IntervalContext";

export default function AdminLayout() {
  const [sidebarVisible, setSidebarVisible] = useState(true);

  const getRoutes = (routes) =>
    routes
      .filter((route) => route.layout === "/admin")
      .map((route, key) => (
        <Route key={key} path={route.path} element={<route.component />} />
      ));

  return (
    <IntervalProvider>
      <div className="flex bg-neutral-950 text-gray-100 min-h-screen">
        {/* Sidebar */}
        {sidebarVisible && <Sidebar />}

        {/* Main Content */}
        <div className="flex-1 ml-64 p-6 transition-all duration-300">
          <Navbar onMenuClick={() => setSidebarVisible(!sidebarVisible)} />
          {/* <div className="pt-20"> */}
          <div>
            <Routes>
              {getRoutes(routes)}
              <Route path="*" element={<Navigate to="/admin/default" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </IntervalProvider>
  );
}